export const SET_BOOKMARKED_SESSIONS_INITIATED_FETCH =
    'SET_BOOKMARKED_SESSIONS_INITIATED_FETCH';
export const SET_BOOKMARKED_SESSIONS = 'SET_BOOKMARKED_SESSIONS';

export function setBookmarkedSessions(payload) {
    return {
        type: SET_BOOKMARKED_SESSIONS,
        payload,
    };
}

export function setBookmarkedSessionsInitiatedFetch(payload) {
    return {
        type: SET_BOOKMARKED_SESSIONS_INITIATED_FETCH,
        payload,
    };
}
